import { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import { Helmet } from 'react-helmet-async';
import qs from 'qs';
import { cbrnResponderCredentialsLoginProviderName, externalLoginProviderName } from '../utils/sharedUtilities';
import ValidatedElement from './ValidatedElement';
import { localSiteHost } from '../utils/sharedUtilities';
import { post } from '../utils/apiUtilities';

function Login({ location, setIsAuthenticated }) {
    const loginWithExternalProvider = "loginWithExternalProvider";
    const loginWithCbrnResponderCredentials = "loginWithCbrnResponderCredentials";

    const queryString = qs.parse(location.search, { ignoreQueryPrefix: true });
    const returnUrl = queryString.ReturnUrl || queryString.returnUrl;
    const hasExternalAuthError = queryString.HasExternalAuthError || queryString.hasExternalAuthError;
    const externalAuthExceptionLogId = queryString.ExternalAuthExceptionLogId || queryString.externalAuthExceptionLogId;
    const externalAuthErrorId = queryString.ExternalAuthErrorId || queryString.externalAuthErrorId;

    const [currentlyAuthenticatedUserName, setCurrentlyAuthenticatedUserName] = useState('');
    const [timezoneOffset, setTimeZoneOffset] = useState(0);
    const [referrerName, setReferrerName] = useState('CBRNResponder');
    const [referralUrl, setReferralUrl] = useState(''); 
    const [errorMessage, setErrorMessage] = useState('');
    const [rememberLogin] = useState(false);
    const [selectedExternalLoginProviderValue, setSelectedExternalLoginProviderValue] = useState('');
    const [showCbrnResponderCredentialsLogin, setShowCbrnResponderCredentialsLogin] = useState(true);
    const [validationEnabled, setValidationEnabled] = useState(false);
    const [validationError, setValidationError] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [externalLoginProviders, setExternalLoginProviders] = useState([]);
    
    const loginType = showCbrnResponderCredentialsLogin ? loginWithCbrnResponderCredentials : loginWithExternalProvider;   

    const login = async (e) => {
        e.preventDefault();
        setValidationEnabled(true);
        setIsLoggingIn(true);

        if (validationError){
            console.log(`Validation Error: ${validationError}`);
            setIsLoggingIn(false);
        }
        else{
            try {
                const d = await post('account/login', {
                    username: userName,
                    password: password,
                    rememberLogin: rememberLogin,
                    returnUrl: returnUrl,
                    timezoneOffset: timezoneOffset,
                    selectedExternalLoginProviderValue: selectedExternalLoginProviderValue,
                    loginType: loginType,
                    errorMessage: ''
                });
                
                setIsAuthenticated(true);
                window.location.href = d.redirect || referralUrl;
            }
            catch (err) {
                setIsLoggingIn(false);
                if (err && err.responseText) {
                    setErrorMessage((err.status === 400 || err.status === 401) ? err.responseText : 'An error occurred while logging in.');
                }
            }
        }
    }

    const init = useCallback(async () => {
        var url = `${localSiteHost}/api/account/login?returnUrl=${(encodeURIComponent(returnUrl) || '')}`;

        if (hasExternalAuthError) {
            url += "&hasExternalAuthError=true";

            if (externalAuthExceptionLogId)
                url += `&externalAuthExceptionLogId=${externalAuthExceptionLogId}`;

            if (externalAuthErrorId)
                url += `&externalAuthErrorId=${externalAuthErrorId}`;
        }

        const d = await $.ajax({
            url: url,
            type: "GET",
            contentType: "application/json"
        });

        //If we get a redirect URL back from the request then always redirect to that URL before continuing processing.
        if (d.redirectUrl) {
            window.location.href = d.redirectUrl;
        }

        setCurrentlyAuthenticatedUserName(d.username);
        setTimeZoneOffset(d.timezoneOffset);
        setReferrerName(d.referrerName);
        setReferralUrl(d.referralUrl);
        setErrorMessage(d.errorMessage);
        setExternalLoginProviders(d.externalLoginProviders);
        setShowCbrnResponderCredentialsLogin(d.showCbrnResponderCredentialsLogin);

        if (d.selectedExternalLoginProviderValue) {
            setSelectedExternalLoginProviderValue(d.selectedExternalLoginProviderValue);
        }
    }, [returnUrl]);

    const getExternalLoginMessageForExternalLoginProvider = (providerId) => {
        for (var i = 0; i < externalLoginProviders.length; i++) {
            if (externalLoginProviders[i].value === providerId) {
                return externalLoginProviders[i].message;
            }
        }
    };

    useEffect(() => {
        init();
    }, [init]);

    return (
        <>
            <Helmet>
                <title>Sign In | CBRN Network</title>
            </Helmet>
            <div id="layout-shell" className="shell top100">
                <div className="main-content container" id="loginCont" tabIndex="-1">
                    <div className="row">
                        <main>
                            {(() => {
                                if (currentlyAuthenticatedUserName) {
                                    return <div className="col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">
                                        <div className="alert alert-success" role="alert">
                                            Currently logged in as
                                            <strong> {currentlyAuthenticatedUserName} </strong>.
                                        </div>
                                    </div>;
                                }
                                else {
                                    if (returnUrl) {
                                        return <div className="col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">
                                            <div className="alert alert-info" role="alert"><strong>Authentication Required</strong> - You must sign in to view the requested page.</div>
                                        </div>;
                                    }
                                }

                                return null;
                            })()}
                            <div className="col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">
                                <form autoComplete="off" className="form-horizontal signin-form" onSubmit={login}>
                                    {(!(errorMessage && errorMessage.length) ? '' : (
                                        <div className="alert alert-danger">
                                            <span dangerouslySetInnerHTML={{ __html: errorMessage }}></span>
                                        </div>
                                    ))}

                                    <ul className="nav nav-tabs">
                                        <li role="presentation" className={ showCbrnResponderCredentialsLogin ? "active " : "" }>
                                            <a href="#cbrnresponder" aria-controls="cbrnresponder" role="tab" data-toggle="tab" onClick={() => setShowCbrnResponderCredentialsLogin(true)}>
                                                <span className="hidden-xs">Sign in to </span>{referrerName}
                                            </a>
                                        </li>
                                        <li role="presentation" className={ !showCbrnResponderCredentialsLogin ? "active " : "" } onClick={() => setShowCbrnResponderCredentialsLogin(false)}>
                                            <a href="#external" aria-controls="external" role="tab" data-toggle="tab">
                                                <span className="hidden-xs">Sign in with </span>External Account
                                            </a>
                                        </li>
                                    </ul>

                                    <div className="panel panel-default panel-with-tabs">
                                        <div className="panel-body">
                                            <div className="tab-content">
                                                <div role="tabpanel" className={`tab-pane fade in${showCbrnResponderCredentialsLogin ? " active" : ""}`} id="cbrnresponder">
                                                    <div className="smaller-75 bottom5">All fields are required</div>
                                                    <div className="form-group">
                                                        <div className="col-sm-12">
                                                            <label className="sr-only" data-bind="uniqueFor: username">Username</label>
                                                            <ValidatedElement validationEnabled={validationEnabled} 
                                                                setValidationError={setValidationError} 
                                                                value={userName}>
                                                                <input autoComplete="off" 
                                                                    className="form-control" 
                                                                    id="Username" 
                                                                    maxLength="100" 
                                                                    name="Username" 
                                                                    placeholder="Username or Email Address" 
                                                                    type="text" 
                                                                    data-required="The Username field is required."
                                                                    data-required-if={ showCbrnResponderCredentialsLogin }
                                                                    value={userName} 
                                                                    onChange={(e) => setUserName(e.target.value)} />
                                                            </ValidatedElement>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="col-sm-12">
                                                            <label className="sr-only" data-bind="uniqueFor: password">Password</label>
                                                            <ValidatedElement validationEnabled={validationEnabled} 
                                                                setValidationError={setValidationError} 
                                                                value={password}>
                                                                <input autoComplete="off"  
                                                                    className="input-validation-error form-control" 
                                                                    id="Password" 
                                                                    maxLength="250" 
                                                                    name="Password" 
                                                                    placeholder="Password" 
                                                                    type="password" 
                                                                    data-required="The Password field is required." 
                                                                    data-required-if={ showCbrnResponderCredentialsLogin }
                                                                    value={password}
                                                                    onChange={(e) => setPassword(e.target.value)} />
                                                            </ValidatedElement>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="col-sm-12">
                                                            <button id="loginButtonCbrnResponderCredentials"
                                                                className="btn btn-success btn-lg btn-block"
                                                                data-loading-text="Signing In..."
                                                                name="button"
                                                                disabled={isLoggingIn}
                                                                value={cbrnResponderCredentialsLoginProviderName}>
                                                                {isLoggingIn ? 'Logging In...' : 'Login'}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="form-group last">
                                                        <div className="col-sm-12 col-md-12">
                                                            <a href={`${referralUrl}app/index#account/resetpassword`} data-bind="click: toggleUserMenu" className="form-control-link">Forgot Password</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-pane fade in ${!showCbrnResponderCredentialsLogin ? "active " : ""}`} id="external">
                                                    <div className="form-group">
                                                        <div className="col-sm-12">
                                                            <label className="sr-only" htmlFor="externalLoginProvider">Select an External Login Provider</label>
                                                            <select className="form-control"
                                                                id="externalLoginProvider"
                                                                name="SelectedExternalLoginProviderValue"
                                                                value={selectedExternalLoginProviderValue}
                                                                onChange={(e) => { setSelectedExternalLoginProviderValue(e.target.value) }}
                                                            >
                                                                {externalLoginProviders.map(x =>
                                                                    <option value={x.value} key={x.value}>{ x.text }</option>
                                                                )}
                                                            </select>
                                                            <span className="field-validation-valid" data-valmsg-for="SelectedExternalLoginProviderValue" data-valmsg-replace="true" />
                                                        </div>
                                                    </div>

                                                    {(() => {
                                                        const msg = getExternalLoginMessageForExternalLoginProvider(selectedExternalLoginProviderValue);

                                                        return <div className={`alert alert-info login-message${msg ? ' active' : ''}`} id="externalLoginMessageContainer">
                                                            <span id="externalLoginMessage">
                                                                {msg}
                                                            </span>
                                                        </div>
                                                    })()}
                                                
                                                    <div className="form-group">
                                                        <div className="col-sm-12">
                                                            <button id="loginButtonExternalLoginProvider" 
                                                                className="btn btn-success btn-lg btn-block" 
                                                                data-loading-text="Signing In..." 
                                                                name="button" 
                                                                value={externalLoginProviderName}
                                                                disabled={isLoggingIn}
                                                                onClick={login}>
                                                                {isLoggingIn ? 'Logging In...' : 'Login'}
                                                            </button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel-footer rr-white-background">
                                            Don't have an account? <a href={`${referralUrl}app/index#account/request`} title={`Request a ${referrerName} account`}>Request one here</a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(Login);
